import React, { Component } from "react";

import styles from "./styles.scss";
import { connect } from "react-redux";
import { actions } from "./redux";
import { Grid, Card, CardContent, Hidden } from "@material-ui/core";
import CSSModules from "react-css-modules";
import * as router from 'react-router-redux';
import moment from "moment";
import {number, seriesColor, deepClone, units} from "../../../utils";
import ReactHighcharts  from 'react-highcharts';
import { Star } from "@material-ui/icons";
import { actions as headerActions } from "../../../components/Header/redux";
import ReportChart from "../../../components/EvidenceComponents/ReportChart/ReportChart";
import HtmlParser from "react-html-parser";
import { CircularProgress } from "@material-ui/core";

const dateFormat = "DD MMM";
const altDateFormat = "dddd, MMM Do, h:mm A";

const columnConfig = {
    chart: {
        type: 'column'
    },
    title: {
        text: 'Cost Comparison',
        align: "left",
        margin: 60,
        style: {
            "color": "#4D4D4D",
            "font-size": "20px",
            "font-weight": "600"
        },
    },
    credits: {
        enabled: false,
    },
    xAxis: {
        type: 'number',
        tickWidth: 0,
        lineColor: '#e6e6e6',
        labels: {
            enabled: false,
            y: 30,
            style: {
                fontSize: "14px",
                color: '#999',
            }
        }
    },
    yAxis: {
        min: 0,
        title: {
            text: "$",
            align: "high",
            rotation: 0,
            margin: 0,
            y: -30,
            offset: 14,
            style: {
                "font-weight": "600",
                "font-size": "15px",
            },
        },
        labels: {
            style: {
                fontSize: "14px",
                color: '#999',
            }
        }
    },
    tooltip: {
        headerFormat: '<span style="font-size:10px"></span><table>',
        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>${point.y:.1f}</b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true
    },
    plotOptions: {
        column: {
            pointPadding: 0.2,
            borderWidth: 0
        }
    },
}

const indexedConfig = {
    chart:{
        animation: false,
        zoomType: "x",
        panning: true,
        panKey: 'shift',
        style: {
            fontFamily: "Helvetica",
        },
        turboThreshold: 0,
    },
    credits: {
        enabled: false,
    },
    colors: seriesColor.getSeriesColors(),
    title: {
      text: "Cost Per Hour",
      align: "left",
      margin: 60,
      style: {
          "color": "#4D4D4D",
          "font-size": "20px",
          "font-weight": "600"
      },
    },
    legend: {
        enabled: false,
    },
    xAxis: {
        type: 'number',
        tickWidth: 0,
        lineColor: '#e6e6e6',
        labels: {
            enabled: false,
            y: 30,
            style: {
                fontSize: "14px",
                color: '#999',
            }
        }
    },
    yAxis: {
        title: {
            text: "$",
            align: "high",
            rotation: 0,
            margin: 0,
            y: -30,
            offset: 14,
            style: {
                "font-weight": "600",
                "font-size": "15px",
            },
        },
        labels: {
            style: {
                fontSize: "14px",
                color: '#999',
            }
        }
    },
    series: [
        {
            type: 'column',
            data: [],
            pointIntervalUnit: 'hour',
            zIndex: 2,
            stack: 0,
            pointPlacement: 'between',
            color: '#2D9BB1',
            name: 'Cost',
            borderWidth: 0,
            pointPadding: 0.08,
            groupPadding: 0,
        }
    ],
    tooltip: {
        shared: true,
        formatter: function() {
            var s = '';
    
            this.points.forEach((point, index) => {
                s+= (index > 0 ? '<br />' : '') + '<b><span style="color:' + point.point.color + '">' + moment(point.point.options.timestamp).utc().format(altDateFormat) + ' - ' + moment(point.point.options.timestamp).add(1, 'hours').utc().format(altDateFormat) + ':</span></b> $' + (point.point.desc ? ("<br />" + point.point.desc.replace('\n', "<br />").replace('\r', "<br />")) : number.parseNumber(point.y) + ' ' + units.getUnitName(point.point.options.units));
            });
    
            return s;
        },
        followTouchMove: false,
    },
};

const combinedConfig = {
    chart:{
        animation: false,
        marginBottom: 85,
        zoomType: "x",
        panning: true,
        panKey: 'shift',
        style: {
            fontFamily: "Helvetica",
        },
        turboThreshold: 0,
    },
    credits: {
        enabled: false,
    },
    colors: seriesColor.getSeriesColors(),
    title: {
        text: "Cost Per Hour",
        align: "left",
        margin: 60,
        style: {
          "color": "#4D4D4D",
          "font-size": "20px",
          "font-weight": "600"
        },
    },
    legend: {
         itemStyle: {
             color: '#999',
             fontWeight: 'normal',
             fontSize: '14px',
         },
         align: 'center',
         verticalAlign: 'bottom',
         layout: 'horizontal',
    },
    tooltip: {
         shared: true,
         formatter: function() {
             var s = '';
     
             this.points.forEach((point, index) => {
                 s+= (index > 0 ? '<br />' : '') + '<b><span style="color:' + point.point.color + '">' + moment(point.point.options.timestamp).utc().format(altDateFormat) + ':</span></b> $' + (point.point.desc ? ("<br />" + point.point.desc.replace('\n', "<br />").replace('\r', "<br />")) : number.parseNumber(point.y) + ' ' + units.getUnitName(point.point.options.units));
             });
     
             return s;
         }
    },
    xAxis: {
        type: 'number',
        tickWidth: 0,
        lineColor: '#e6e6e6',
        labels: {
            enabled: false
        }
    },
    yAxis: {
        title: {
            text: "$",
            align: "high",
            rotation: 0,
            margin: 0,
            y: -30,
            offset: 14,
            style: {
                "font-weight": "600",
                "font-size": "15px",
            },
        },
        labels: {
            style: {
                fontSize: "14px",
                color: '#999',
            }
        }
    },
    plotOptions: {
        line: {
            marker: {
                enabled: false
            }
        }
    },
    series: [],
};



@CSSModules(styles, { allowMultiple: true })
class Live extends Component {
    constructor(props) {
        super(props);

        this.state = {
            iEnergyViewId: this.props.match.params.iEnergyViewId,
            dataType: this.props.match.params.dataType,
            id: this.props.match.params.id,
            siteName: this.props.match.params.siteName,
            selectedTab: "combined",
            chart0: React.createRef(),
            chart1: React.createRef(),
            chart2: React.createRef(),
            chart3: React.createRef(),
            chart4: React.createRef(),
            chart5: React.createRef(),
            chartCombined: React.createRef(),
            costChart: React.createRef(),
            chart0config: deepClone(indexedConfig),
            chart1config: deepClone(indexedConfig),
            chart2config: deepClone(indexedConfig),
            chart3config: deepClone(indexedConfig),
            chart4config: deepClone(indexedConfig),
            chart5config: deepClone(indexedConfig),
            chartCombinedConfig: deepClone(combinedConfig),
            costChartConfig: deepClone(columnConfig),
        };
        
        this.setup = this.setup.bind(this);
    }

    setup(){
        if(this.state.chart0.current && this.state.chart1.current && this.state.chart2.current && this.state.chart3.current && this.state.chart4.current && this.state.chart5.current && this.state.chartCombined.current && this.state.costChart.current) {
            if(this.props.currentLoadedIEnergyViewId !== this.state.iEnergyViewId || this.props.currentLoadedDataType !== this.state.dataType || this.props.currentLoadedId !== this.state.id) {  
                if(this.props.currentSite && this.props.currentTariff) {
                    this.props.loadData(this.state.iEnergyViewId, this.state.dataType, this.state.id, this.state.siteName, this.props.navigate, this.state.chart0, this.state.chart1, this.state.chart2, this.state.chart3, this.state.chart4, this.state.chart5, this.state.chartCombined, this.state.costChart);
                    this.state.chart0.current.getChart().reflow();
                    this.state.chart1.current.getChart().reflow();
                    this.state.chart2.current.getChart().reflow();
                    this.state.chart3.current.getChart().reflow();
                    this.state.chart4.current.getChart().reflow();
                    this.state.chart5.current.getChart().reflow();
                }
            }
        }
    }

    componentDidMount(){
        this.setup();
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        this.setup();
    }

    componentWillMount() {
      this.props.toggleHeaderSelect(false);
    }
    
    componentWillUnmount() {
        this.props.clearData();
        this.props.toggleHeaderSelect(true);

        this.setState({
            iEnergyViewId: null,
            dataType: null,
            id: null,
            siteName: null,
            chart0: undefined,
            chart1: undefined,
            chart2: undefined,
            chart3: undefined,
            chart4: undefined,
            chart5: undefined,
            chartCombined: undefined,
            costChart: undefined,
            chart0config: undefined,
            chart1config: undefined,
            chart2config: undefined,
            chart3config: undefined,
            chart4config: undefined,
            chart5config: undefined,
            chartCombinedConfig: undefined,
        });
    }

    getDynamicConfig(data) {
        let dynamicConfig = {
            chart:{
                animation: false,
                style: {
                    fontFamily: "Helvetica",
                },
                turboThreshold: 0,
            },
            credits: {
                enabled: false,
            },
            colors: ['#2D9BB1', '#556CAB', '#0F2748'],
            title: {
              text: "",
              align: "left",
              margin: 60,
              style: {
                  "color": "#4D4D4D",
                  "font-size": "20px",
                  "font-weight": "600"
              },
            },
            legend: {
                enabled: false,
            },
            xAxis: {
                type: 'number',
                tickWidth: 0,
                lineColor: '#e6e6e6',
                labels: {
                    y: 30,
                    style: {
                        fontSize: "14px",
                        color: '#999',
                    }
                }
            },
            yAxis: {
                title: {
                    text: "$",
                    align: "high",
                    rotation: 0,
                    margin: 0,
                    y: -30,
                    offset: 14,
                    style: {
                        "font-weight": "600",
                        "font-size": "15px",
                    },
                },
                labels: {
                    style: {
                        fontSize: "14px",
                        color: '#999',
                    }
                }
            },
            series: [],
            tooltip: {
                pointFormat: '<span style="color:{point.color}">\u25CF</span> <b> ${point.y:,.2f}</b><br/>',
                followTouchMove: false,
            },
        };

        data.forEach(d => {
            dynamicConfig.series.push({
                data: d.values,
                name: d.description,
            });
        });
        
        return dynamicConfig;
    }

    getSiteName(){
        let siteName = "";
        if(this.props.currentSite){
            siteName = this.props.currentSite.name;
        }
        siteName = siteName.replace("Site_", "");
        return siteName;
    }

    format(x, decimals){
		if(!x){ return 0; }
		if(decimals !== null && decimals !== undefined){
            x = number.parseNumber(x, decimals);
		}
		var parts = x.toString().split(".");
		parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		return parts.join(".");
	}
    
    renderHeader(){
        return(
            <div styleName="header">
                <div styleName="header-title header-minimal-padding">
                    <div>
                    {this.state.dataType === "PreSetTest" ? 'Pre-Set Test Report' : 'Implemented Change Report'}
                    {' ('}
                    {(this.state.siteName && this.state.siteName !== "undefined" && this.state.siteName !== "null") ? this.state.siteName.substring("Site_".length) : null}
                    {')'}
                    </div>
                </div>
                <Grid container styleName="header-content" spacing={0}>
                    <Grid item xs={12}>
                        <div style={{paddingLeft: 10, paddingTop: 10, paddingBottom: 3, fontSize: 12, color: '#999'}}>
                            {
                                ((this.props.gatheredData !== undefined && this.props.gatheredData !== null) &&
                                (this.props.gatheredData[0] !== undefined && this.props.gatheredData[0] !== null)) &&
                                ((this.state.dataType === "PreSetTest" ? 'Pre-Set Test on ' : 'Implemented Change on ') + moment(this.props.gatheredData[0].startDate).utc().format(dateFormat) + ' - ' + moment(this.props.gatheredData[0].endDate).utc().format(dateFormat) + ' (' + moment(this.props.gatheredData[0].startDate).utc().format("YYYY") + ')')
                            }
                        </div>
                        {
                            this.props.isBusy && 
                            <div styleName="header-busy">
                                <CircularProgress />
                            </div>
                        }
                        <div style={{minHeight: 60, paddingLeft: 10}}>
                            {this.props.description}
                        </div>
                        {
                            (
                                this.props.gatheredData !== undefined && 
                                this.props.gatheredData !== null &&
                                this.props.gatheredData[this.props.gatheredData.length - 1] !== undefined && 
                                this.props.gatheredData[this.props.gatheredData.length - 1] !== null &&
                                this.props.gatheredData[this.props.gatheredData.length - 1].endDate.valueOf() > new Date().getTime()
                            ) &&
                            <div style={{paddingLeft: 10, paddingTop: 5, paddingBottom: 3, fontSize: 12, color: '#999'}}>
                                This report is currently in progress
                            </div>
                        }
                    </Grid>
                </Grid>
            </div>
        );
    }

    parseName(name) {
        if(!name) return name;
        let split = name.split(".");
        
        let needed = split.slice(1, split.length - 1);

        if(needed.length > 0) {
            return needed.join(" ");
        } else {
            return name;
        }
    }

    checkIfHeightAdjustmentNeeded(units) {
        if(!units || !units.toLowerCase) return false;
        if(units.toLowerCase() === "kwh" || units.toLowerCase() === "count" || units.toLowerCase() === "seats") {
            return false;
        }
        return true;
    }

    renderGatheredValues(data, isLast) {
        const containerStyleName = isLast ? "value-container value-force-center value-right-container" : "value-container value-underline value-right-container";

        if(!this.checkIfHeightAdjustmentNeeded(data.units)) {
            return (
                <div styleName={containerStyleName + " value-row value-container-min"}>
                    <div styleName="value-value">{data.value ? number.parseNumber(data.value) : ""}</div>
                    <div styleName="value-label value-left-gap">{data.units}</div>
                </div>
            )
        } else {
            return (
                <div styleName={containerStyleName}>
                    <div styleName="value-label" style={{width: "100%", textAlign: "center"}}>{this.parseName(data.name)}</div>
                    <div styleName="value-container value-container-min value-row">
                        <div styleName="value-container value-row no-bottom-margin">
                            <div styleName="value-value">{data.min ? number.parseNumber(data.min, 1) : "0"}</div>
                            <div styleName="value-label value-left-gap">min</div>
                        </div>
                        <div styleName="value-divider" />
                        <div styleName="value-container value-row">
                            <div styleName="value-value">{data.avg ? number.parseNumber(data.avg, 1) : "0"}</div>
                            <div styleName="value-label value-left-gap">avg</div>
                        </div>
                        <div styleName="value-divider" />
                        <div styleName="value-container value-row">
                            <div styleName="value-value">{data.max ? number.parseNumber(data.max, 1): "0"}</div>
                            <div styleName="value-label value-left-gap">max</div>
                        </div>
                    </div>
                </div>
            )
        }
    }

    renderGatheredValuesSmall(data, isLast, index, containerSize) {
        if(!this.checkIfHeightAdjustmentNeeded(data.units)) {
            return (
                <div style={{display:'flex',flexDirection:'row'}}>
                    <div styleName="value-value" style={{paddingTop:8,fontSize:containerSize>8?18:20}}>{data.value ? number.parseNumber(data.value) : ""}</div>
                </div>
            )
        } else {
            return (
                <div style={{display:'flex',flexDirection:'row'}}>
                    <div styleName="value-value" style={{flex:'1 1 0',paddingTop:8,fontSize:containerSize>8?18:20}} isstar={(this.props.bestIndex === index).toString()}>{data.min ? number.parseNumber(data.min, 1) : "0"}</div>
                    <div styleName="value-value" style={{flex:'1 1 0',paddingTop:8,fontSize:containerSize>8?18:20}} isstar={(this.props.bestIndex === index).toString()}>{data.avg ? number.parseNumber(data.avg, 1) : "0"}</div>
                    <div styleName="value-value" style={{flex:'1 1 0',paddingTop:8,fontSize:containerSize>8?18:20}} isstar={(this.props.bestIndex === index).toString()}>{data.max ? number.parseNumber(data.max, 1): "0"}</div>
                </div>
            )
        }
    }

	render() {
        console.log("Evidence Render");
        var containerSize = 6;	
        if(this.props.gatheredData && this.props.gatheredData[0] && this.props.gatheredData[0].values && this.props.gatheredData[0].values.length) {
            if(this.props.gatheredData[0].values.length === 3) {
                containerSize = 12;
            } else if(this.props.gatheredData[0].values.length === 2) {
                containerSize = 10;
            } else if(this.props.gatheredData[0].values.length === 1) {
                containerSize = 8;
            }
        }
		return (
            <Grid container styleName="page-wrapper">
                <Grid item xs={12} styleName="item-wrapper">
                    <Card styleName="live-card">
                        {this.renderHeader()}
                    </Card>
                </Grid>
                <Grid item xs={0} md={12}>
                    {
                        this.props.hasLoadedData &&
                        <Grid item xs={12} styleName="item-wrapper show-only-desktop">
                            <Card styleName="live-card" style={{overflow:'auto'}}>
                                <Grid container style={{display:'flex',flexDirection:'row',flexWrap:'nowrap'}}>
                                    <Grid item xs={containerSize === 6 ? 2 : 1} styleName="summary-table-header min-w-100">
                                        Date
                                    </Grid>
                                    <Grid item xs={containerSize === 6 ? 2 : 1} styleName="summary-table-header min-w-100">
                                        Adjustment
                                    </Grid>
                                    <Grid item xs={containerSize === 6 ? 2 : 1} styleName="summary-table-header min-w-100">
                                        Cost
                                    </Grid>
                                    <Grid item xs={containerSize === 6 ? 2 : 1} styleName="summary-table-header min-w-100">
                                        kWh
                                    </Grid>
                                    <Grid item xs={containerSize === 6 ? 4 : 2} styleName="summary-table-header min-w-200">
                                        <div>Demand</div>
                                        <div style={{display:'flex',flexDirection:'row'}}>
                                            <div style={{flex:'1 1 0'}}>
                                                (Min)
                                            </div>
                                            <div style={{flex:'1 1 0'}}>
                                                (Max)
                                            </div>
                                        </div>
                                    </Grid>
                                    {
                                        this.props.gatheredData &&
                                        this.props.gatheredData[0] &&
                                        this.props.gatheredData[0].values &&
                                        this.props.gatheredData[0].values[0] &&
                                        this.props.gatheredData[0].values[0].name !== undefined &&
                                        <Grid item xs={2} styleName="summary-table-header min-w-200">
                                            {
                                                this.parseName(this.props.gatheredData[0].values[0].name)
                                            }
                                            {
                                                this.checkIfHeightAdjustmentNeeded(this.props.gatheredData[0].values[0].units) &&
                                                <div style={{display:'flex',flexDirection:'row'}}>
                                                    <div style={{flex:'1 1 0'}}>(Min)</div>
                                                    <div style={{flex:'1 1 0'}}>(Avg)</div>
                                                    <div style={{flex:'1 1 0'}}>(Max)</div>
                                                </div>
                                            }
                                        </Grid>
                                    }
                                    {
                                        this.props.gatheredData &&
                                        this.props.gatheredData[0] &&
                                        this.props.gatheredData[0].values &&
                                        this.props.gatheredData[0].values[1] &&
                                        this.props.gatheredData[0].values[1].name !== undefined &&
                                        <Grid item xs={2} styleName="summary-table-header min-w-200">
                                            <div style={{display:'flex',flexDirection:'column'}}>
                                                {
                                                    this.parseName(this.props.gatheredData[0].values[1].name)
                                                }
                                                {
                                                    this.checkIfHeightAdjustmentNeeded(this.props.gatheredData[0].values[1].units) &&
                                                    <div style={{display:'flex',flexDirection:'row'}}>
                                                        <div style={{flex:'1 1 0'}}>(Min)</div>
                                                        <div style={{flex:'1 1 0'}}>(Avg)</div>
                                                        <div style={{flex:'1 1 0'}}>(Max)</div>
                                                    </div>
                                                }
                                            </div>
                                            
                                        </Grid>
                                    }
                                    {
                                        this.props.gatheredData &&
                                        this.props.gatheredData[0] &&
                                        this.props.gatheredData[0].values &&
                                        this.props.gatheredData[0].values[2] &&
                                        this.props.gatheredData[0].values[2].name !== undefined &&
                                        <Grid item xs={2} styleName="summary-table-header min-w-200">
                                            {
                                                this.parseName(this.props.gatheredData[0].values[2].name)
                                            }
                                            {
                                                this.props.gatheredData[0].values[2].units &&
                                                this.checkIfHeightAdjustmentNeeded(this.props.gatheredData[0].values[2].units) &&
                                                <div style={{display:'flex',flexDirection:'row'}}>
                                                    <div style={{flex:'1 1 0'}}>(Min)</div>
                                                    <div style={{flex:'1 1 0'}}>(Avg)</div>
                                                    <div style={{flex:'1 1 0'}}>(Max)</div>
                                                </div>
                                            }
                                        </Grid>
                                    }
                                </Grid>
                                {
                                    this.props.gatheredData &&
                                    this.props.gatheredData.map((data, index) => {
                                        return (
                                            <Grid key={index} container style={{display:'flex',flexDirection:'row',flexWrap:'nowrap'}}>
                                                <Grid item xs={containerSize === 6 ? 2 : 1} styleName="summary-table-value-b min-w-100" style={{display:'flex',flexDirection:'column'}}>
                                                    <div style={{textAlign:'center'}}>{moment(data.startDate).format("YYYY")}</div>
                                                    <div style={{textAlign:'center'}}>{moment(data.startDate).format("DD MMM")} - {moment(data.endDate).format("DD MMM")}</div>
                                                </Grid>
                                                <Grid item xs={containerSize === 6 ? 2 : 1} styleName="summary-table-value-b min-w-100">
                                                    <div styleName="value-value" style={{paddingTop:8,fontSize:containerSize>8?18:20}} isstar={(this.props.bestIndex === index).toString()}>
                                                        {data.description}
                                                    </div>
                                                </Grid>
                                                <Grid item xs={containerSize === 6 ? 2 : 1} styleName="summary-table-value-b min-w-100">
                                                    <div styleName="value-value cost" style={{paddingTop:8,fontSize:containerSize>8?18:20}} isstar={(this.props.bestIndex === index).toString()}>
                                                        ${data.costs ? number.parseNumber(data.costs,2) : "0"}
                                                    </div>
                                                </Grid>
                                                <Grid item xs={containerSize === 6 ? 2 : 1} styleName="summary-table-value-b min-w-100">
                                                    <div styleName="value-value" style={{paddingTop:8,fontSize:containerSize>8?18:20}} isstar={(this.props.bestIndex === index).toString()}>
                                                        {data.kWh ? number.parseNumber(data.kWh) : "0"}
                                                    </div>
                                                </Grid>
                                                <Grid item xs={containerSize === 6 ? 4 : 2} styleName="summary-table-value-b min-w-200" style={{display:'flex',flexDirection:'row'}}>
                                                    <div styleName="value-value" style={{flex:'1 1 0',paddingTop:8,fontSize:containerSize>8?18:20}} isstar={(this.props.bestIndex === index).toString()}>
                                                        ${data.demandMin ? number.parseNumber(data.demandMin,2) : "0"}
                                                    </div>
                                                    <div styleName="value-value" style={{flex:'1 1 0',paddingTop:8,fontSize:containerSize>8?18:20}} isstar={(this.props.bestIndex === index).toString()}>
                                                        ${data.demandMax ? number.parseNumber(data.demandMax,2) : "0"}
                                                    </div>
                                                </Grid>
                                                {
                                                    (data.values && data.values.length > 0) &&
                                                    data.values[0].name !== undefined &&
                                                    <Grid item xs={2} styleName="summary-table-value-b min-w-200">
                                                        {
                                                            this.renderGatheredValuesSmall(data.values[0], false, index, containerSize)
                                                        }
                                                    </Grid>
                                                }
                                                {
                                                    (data.values && data.values.length > 1) &&
                                                    data.values[1].name !== undefined &&
                                                    <Grid item xs={2} styleName="summary-table-value-b min-w-200">
                                                        {
                                                            this.renderGatheredValuesSmall(data.values[1], false, index, containerSize)
                                                        }
                                                    </Grid>
                                                }
                                                {
                                                    (data.values && data.values.length > 2) &&
                                                    data.values[2].name !== undefined &&
                                                    <Grid item xs={2} styleName="summary-table-value-b min-w-200">
                                                        {
                                                            this.renderGatheredValuesSmall(data.values[2], true, index, containerSize)
                                                        }
                                                    </Grid>
                                                }
                                            </Grid>
                                        )
                                    })
                                }
                            </Card>
                        </Grid>
                    }
                </Grid>

                <Grid item xs={12} md={6}>
                    <Grid container spacing={0}>
                        <Grid item xs={12} styleName="item-wrapper">
                            <Card styleName="live-card" style={{display: this.props.hasLoadedData ? "block" : "none" }}>
                                <ReactHighcharts
                                    config={this.state.costChartConfig}
                                    ref={this.state.costChart}
                                    isPureConfig={true}
                                />
                            </Card>
                        </Grid>
                    </Grid>

                    <Grid container spacing={0}>
                        {
                            this.props.gatheredData &&
                            this.props.gatheredData.map((data, index) => {
                                return (
                                    <Grid key={index} item xs={12} styleName="item-wrapper show-only-tablet-or-less">
                                        <Card styleName="live-card">
                                            <div styleName="header-title" isstar={(this.props.bestIndex === index).toString()}>
                                                <div styleName="header-year">{moment(data.startDate).format("YYYY")}</div>
                                                <div styleName="header-day-month">{moment(data.startDate).format("DD MMM")} - {moment(data.endDate).format("DD MMM")}</div>
                                                <Star styleName="header-icon" isstar={(this.props.bestIndex === index).toString()} />
                                            </div>
                                            <Grid container styleName="header-content" spacing={0}>
                                                <Grid item xs={12}>
                                                    <div style={{flex: 1, minHeight: 60, padding: 10}}>
                                                        <Grid container>
                                                            {
                                                                data.description && 
                                                                <Grid item xs={12}>
                                                                    <div styleName="value-container value-container-min value-underline value-column value-force-center">
                                                                        <div styleName="value-value">{data.description}</div>
                                                                        {
                                                                            this.state.dataType === "PreSetTest" &&
                                                                            <div styleName="value-label">Adjustment</div>
                                                                        }
                                                                    </div>
                                                                </Grid>
                                                            }
                                                            <Grid item xs={12} sm={6}>
                                                                <div styleName="value-container value-container-min value-underline value-row value-left-container" style={{ height: data.values[0] && this.checkIfHeightAdjustmentNeeded(data.values[0].units) ? 79 : "unset"}}>
                                                                    <div styleName="value-cost">${data.costs ? number.parseNumber(data.costs) : "0"}</div>
                                                                    <div styleName="value-label value-left-gap">cost</div>
                                                                </div>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6}>
                                                                {
                                                                    (data.values && data.values.length > 0) &&
                                                                    this.renderGatheredValues(data.values[0], false)
                                                                }
                                                            </Grid>
                                                            
                                                            <Grid item xs={12} sm={6}>
                                                                <div styleName="value-container value-container-min value-underline value-row value-left-container" style={{ height: data.values[1] && this.checkIfHeightAdjustmentNeeded(data.values[1].units) ? 79 : "unset"}}>
                                                                    <div styleName="value-value">{data.kWh ? number.parseNumber(data.kWh) : "0"}</div>
                                                                    <div styleName="value-label value-left-gap">kWh</div>
                                                                </div>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6}>
                                                                {
                                                                    (data.values && data.values.length > 1) &&
                                                                    this.renderGatheredValues(data.values[1], false)
                                                                }
                                                            </Grid>
                                                            <Grid item xs={12} sm={6}>
                                                                <div styleName="value-container value-column value-left-container value-force-center">
                                                                    <div styleName="value-label">Demand</div>
                                                                    <div styleName="value-container value-row">
                                                                        <div styleName="value-container value-container-min value-row no-bottom-margin">
                                                                            <div styleName="value-value">${data.demandMin ? number.parseNumber(data.demandMin) : "0"}</div>
                                                                            <div styleName="value-label value-left-gap">min</div>
                                                                        </div>
                                                                        <div styleName="value-divider" />
                                                                        <div styleName="value-container value-container-min value-row">
                                                                            <div styleName="value-value">${data.demandMax ? number.parseNumber(data.demandMax) : "0"}</div>
                                                                            <div styleName="value-label value-left-gap">max</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Grid>
                                                            
                                                            <Grid item xs={12} sm={6}>
                                                                {
                                                                    (data.values && data.values.length > 2) &&
                                                                    this.renderGatheredValues(data.values[2], true)
                                                                }
                                                            </Grid>
                                                        </Grid>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </Card>
                                    </Grid>
                                );
                            })
                        }
                    </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Grid container spacing={0}>
                        <Grid item xs={12} styleName="item-wrapper">
                            <Card styleName="live-card" hasdata={(this.props.gatheredData && this.props.gatheredData.length > 0) ? "true" : "false"}>
                                <div styleName="selectable-tab-container">
                                    {
                                        this.props.gatheredData &&
                                        this.props.gatheredData.map((data, index) => {
                                            return (
                                                <div key={index} styleName="selectable-tab" iscombined="false" isstar={(this.props.bestIndex === index).toString()} isselected={this.state.selectedTab === index ? "true" : "false"} onClick={() => {this.setState({selectedTab: index}); this.props.setSelectedTab(index, this.state.chart0, this.state.chart1, this.state.chart2, this.state.chart3, this.state.chart4, this.state.chart5, this.state.chartCombined);}}>
                                                    <div styleName="selectable-tab-year">{moment(data.startDate).format("YYYY")}</div>
                                                    <div styleName="selectable-tab-header-day-month">{moment(data.startDate).format("DD MMM")} - {moment(data.endDate).format("DD MMM")}</div>
                                                </div>
                                            )
                                        })
                                    }
                                    <div styleName="selectable-tab" iscombined="true" isselected={this.state.selectedTab === "combined" ? "true" : "false"} onClick={() => this.setState({selectedTab: "combined"})}>
                                        <div styleName="selectable-tab-combined">Combine Dates</div>
                                    </div>
                                </div>

                                {/* These have to be loaded into the DOM in order for highcharts to populate them properly. This is why it isn't a loop with a dynamic amount of charts. */}

                                <div styleName="chartContainer" ismenuopen={this.props.isMenuOpen.toString()} style={{display: this.state.selectedTab === 0 ? undefined : "none"}}>
                                    <ReactHighcharts
                                        config={this.state.chart1config}
                                        ref={this.state.chart0}
                                        isPureConfig={true}
                                    />
                                </div>
                                
                                <div styleName="chartContainer" ismenuopen={this.props.isMenuOpen.toString()} style={{display: this.state.selectedTab === 1 ? undefined : "none"}}>
                                    <ReactHighcharts
                                        config={this.state.chart1config}
                                        ref={this.state.chart1}
                                        isPureConfig={true}
                                    />
                                </div>
                                
                                <div styleName="chartContainer" ismenuopen={this.props.isMenuOpen.toString()} style={{display: this.state.selectedTab === 2 ? undefined : "none"}}>
                                    <ReactHighcharts
                                        config={this.state.chart2config}
                                        ref={this.state.chart2}
                                        isPureConfig={true}
                                    />
                                </div>
                                
                                <div styleName="chartContainer" ismenuopen={this.props.isMenuOpen.toString()} style={{display: this.state.selectedTab === 3 ? undefined : "none"}}>
                                    <ReactHighcharts
                                        config={this.state.chart3config}
                                        ref={this.state.chart3}
                                        isPureConfig={true}
                                    />
                                </div>
                                
                                <div styleName="chartContainer" ismenuopen={this.props.isMenuOpen.toString()} style={{display: this.state.selectedTab === 4 ? undefined : "none"}}>
                                    <ReactHighcharts
                                        config={this.state.chart4config}
                                        ref={this.state.chart4}
                                        isPureConfig={true}
                                    />
                                </div>
                                
                                <div styleName="chartContainer" ismenuopen={this.props.isMenuOpen.toString()} style={{display: this.state.selectedTab === 5 ? undefined : "none"}}>
                                    <ReactHighcharts
                                        config={this.state.chart5config}
                                        ref={this.state.chart5}
                                        isPureConfig={true}
                                    />
                                </div>
                                
                                <div styleName="chartContainer" ismenuopen={this.props.isMenuOpen.toString()} style={{display: this.state.selectedTab === "combined" ? undefined : "none"}}>
                                    <ReactHighcharts
                                        config={this.state.chartCombinedConfig}
                                        ref={this.state.chartCombined}
                                        isPureConfig={true}
                                    />
                                </div>
                            </Card>
                        </Grid>
                        
                        {
                            ((this.props.extendedChartData !== undefined && this.props.extendedChartData !== null) &&
                            (this.props.extendedChartData.length !== undefined && this.props.extendedChartData.length !== null && this.props.extendedChartData.length > 0)) &&
                            this.props.extendedChartData.map((chartData, index) => {
                                return (
                                    <Grid key={index} item xs={12} styleName="item-wrapper" hasdata={(chartData && chartData.length > 0) && this.state.selectedTab !== "combined" ? "true" : "false"}>
                                        <Card styleName="live-card" hasdata={(chartData && chartData.length > 0) ? "true" : "false"}>
                                            {
                                                chartData &&
                                                chartData.length &&
                                                chartData.map((cdata, index) => {
                                                    return (
                                                        <div key={"rh_" + index} styleName="chartContainer" style={{display: this.state.selectedTab === index ? undefined : "none"}}>
                                                            <ReportChart data={cdata} showing={this.state.selectedTab === index} />
                                                        </div>
                                                    )
                                                })
                                            }
                                        </Card>
                                    </Grid>
                                );
                            })
                        }
                        {((this.props.extendedChartData !== undefined && this.props.extendedChartData !== null) &&
                            (this.props.extendedChartData.length !== undefined && this.props.extendedChartData.length !== null && this.props.extendedChartData.length > 0)) &&
                            this.props.extendedChartData.map((chartData, index) => {
                                return (
                                    <Grid key={index} item xs={12} styleName="item-wrapper" hasdata={(chartData && chartData.length > 0) ? "true" : "false"}>
                                        <Card styleName="live-card" hasdata={(chartData && chartData.length > 0) ? "true" : "false"}>
                                            <div key={"rh_" + index} styleName="chartContainer" style={{display: this.state.selectedTab === "combined" ? undefined : "none"}}>
                                                <ReportChart data={chartData.map(cd => {return cd})} showing={this.state.selectedTab === "combined"} />
                                            </div>
                                        </Card>
                                    </Grid>
                                );
                            })
                        }
                    </Grid>
                </Grid>
			</Grid>
		);
    }
}

const bindAction = dispatch => {
	return {
        loadData: (iEnergyViewId, dataType, id, siteName, navigateFunc, c0, c1, c2, c3, c4, c5, cc, cost) => dispatch(actions.loadData(iEnergyViewId, dataType, id, siteName, navigateFunc, c0, c1, c2, c3, c4, c5, cc, cost)),
        clearData: () => dispatch(actions.clearData()),
        setSelectedTab: (index, c0, c1, c2, c3, c4, c5, cc) => dispatch(actions.setSelectedTab(index, c0, c1, c2, c3, c4, c5, cc)),

        toggleHeaderSelect: (val) => dispatch(headerActions.toggleHeaderSelect(val)),
        
        navigate: (uri, data) => dispatch(router.push(uri, data)),
        goBack: () => dispatch(router.goBack())
	};
};

const mapStateToProps = state => ({
    flattenedSiteTree: state.sitetree.flattenedSiteTree,
    currentSite: state.sitetree.currentSite,
    currentTariff: state.tariffs.currentTariff,

    currentLoadedIEnergyViewId: state.evidenceReport.currentLoadedIEnergyViewId,
    currentLoadedDataType: state.evidenceReport.currentLoadedDataType,
    currentLoadedId: state.evidenceReport.currentLoadedId,

    gatheredData: state.evidenceReport.gatheredData,
    description: state.evidenceReport.description,
    bestIndex: state.evidenceReport.bestIndex,
    isBusy: state.evidenceReport.isBusy,
    extendedChartData: state.evidenceReport.extendedChartData,
    hasLoadedData: state.evidenceReport.hasLoadedData,
    isMenuOpen: state.menu.isOpen,
});

export default connect(mapStateToProps, bindAction)(Live);



// WEBPACK FOOTER //
// ./src/ui/Evidence/Report/EvidenceReport.js